import React from 'react';
import { bonuses } from '../data/kit';
export function Bonuses() {
  return <section className="bg-wine py-9 md:py-16 px-4" data-id="element-12" data-mp="pjzkxa465ib9">
      <div className="max-w-5xl mx-auto" data-id="element-13" data-mp="pjg5c01zr60e">
        <div className="text-center mb-6 md:mb-10 max-w-3xl mx-auto" data-id="element-14" data-mp="av35ut3p3515">
          <h2 className="font-serif text-[25px] md:text-[42px] font-bold text-white tracking-tight leading-[1.12]" data-id="element-15" data-mp="authf9yat5xk">
            3 RECURSOS PARA CUANDO NECESITÁS ALGO CONCRETO
          </h2>
          <p className="text-white/75 text-[15px] md:text-lg leading-snug mt-2.5 md:mt-4" data-id="element-16" data-mp="1t3o1ykuvwx5">
            No son material de relleno. Cada uno cumple una función distinta
            dentro de esta etapa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4" data-id="element-17" data-mp="3t0ok2b1f9pqw">
          {bonuses.map((bono, i) => <article key={bono.title} className="flex flex-col rounded-2xl border border-rose-300/30 bg-wine-dark overflow-hidden" data-id="element-18" data-mp="1mai4e1bjy4yd" data-mpi={i}>
              {bono.image && <div className="bg-cream-50 aspect-[4/3] md:aspect-[3/4] overflow-hidden" data-id="element-19" data-mp="3idwo1ipbnakp">
                  <img src={bono.image} alt={`Vista previa de ${bono.title}`} className="w-full h-full object-cover object-top" loading="lazy" decoding="async" data-id="element-20" data-mp="3dfld14naiu0w" />
                </div>}
              <div className="flex gap-3.5 md:flex-col md:gap-0 p-4 md:p-6" data-id="element-21" data-mp="2zesk2ocn06zw">
                <p className="font-serif text-3xl md:text-4xl font-bold text-rose-300 leading-none tabular-nums shrink-0" data-id="element-22" data-mp="2ugqz1xvnhxls">
                  {String(i + 1).padStart(2, '0')}
                </p>
                <div className="min-w-0" data-id="element-23" data-mp="33h5qlez7k8xq">
                  <h3 className="font-bold text-white text-base md:text-lg leading-snug md:mt-3" data-id="element-24" data-mp="33ge3ytnl9ljl">
                    {bono.title}
                  </h3>
                  <p className="font-serif italic text-rose-200 text-[15px] leading-snug mt-1" data-id="element-25" data-mp="iqygo8nkweyp">
                    {bono.lead}
                  </p>
                  <p className="text-white/65 text-sm leading-snug md:leading-relaxed mt-1.5" data-id="element-26" data-mp="3ci4xxliw3xw1">
                    {bono.desc}
                  </p>
                </div>
              </div>
            </article>)}
        </div>
      </div>
    </section>;
}